// ABOUTME: Content panel card wrapping header, scrollable body, and footer.
// ABOUTME: Uses DashboardCard from @hm/fundamental with flex column layout so the body scrolls independently.
import {DashboardCard} from '@hm/fundamental'
import React from 'react'

import {EntityContentPanelProps} from '../types'

export const EntityContentPanel: React.FC<EntityContentPanelProps> = ({
  header,
  footer,
  children,
  className,
}) => {
  return (
    <DashboardCard className={`flex flex-col h-full min-h-[calc(100vh-200px)] !p-0${className ? ` ${className}` : ''}`}>
      {header}
      <div className="flex-1 overflow-y-auto max-h-[calc(100vh-280px)] [scrollbar-width:thin] [scrollbar-color:var(--border)_var(--container_background)]">{children}</div>
      {footer}
    </DashboardCard>
  )
}
